import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Color from 'color';
import difference from 'lodash/difference';
import includes from 'lodash/includes';
import { setColors } from '../../actions/ui';
import { imageColors, textColor, themeColors } from '../../lib/Color';
import { RESPONSIVE_SIZE } from '../../constants';
import ClipThumbnailGrid from '../ClipThumbnailGrid';
import ScenePoster from '../ScenePoster';
import Section from '../Section';
import { H5 } from '../Typography';

class SceneLayout extends React.PureComponent {
  static propTypes = {
    responsive: PropTypes.number,
    allClips: PropTypes.array.isRequired,
    matchingClips: PropTypes.array,
    colors: PropTypes.object,
    updateColors: PropTypes.func,
  };
  static defaultProps = {
    matchingClips: undefined,
  };

  componentWillMount() {
    this.props.updateColors(themeColors(this.props.allClips[0].scene_colors));
  }

  render() {
    const {
      responsive,
      allClips,
      matchingClips,
      colors,
      updateColors,
      ...otherProps
    } = this.props;
    const masterClip = allClips[0];

    const colorTextDark = textColor(colors.dark);
    const colorTextLight = textColor(colors.light);

    // Multiple sections?
    let otherClips;
    let splitClips = false;
    if (matchingClips !== undefined && matchingClips.length) {
      // TODO: Filter matching to a subset of all.
      const matchingIds = matchingClips.map(c => c.clip_id);
      const allIds = allClips.map(c => c.clip_id);
      const otherIds = difference(allIds, matchingIds);
      otherClips = allClips.filter(c => otherIds.includes(c.clip_id));
      splitClips = true;
    }

    let topShift = '-25rem';
    let bottomShift = '10rem';
    let posterPadding = '5rem 1rem 20rem';
    let gridPadding = '0 1.5rem 7rem';

    if (responsive >= RESPONSIVE_SIZE.PHONE) {
      gridPadding = '0 3rem 7rem';
    }

    if (responsive >= RESPONSIVE_SIZE.TABLET_LANDSCAPE) {
      topShift = '-35rem';
      bottomShift = '20rem';
      posterPadding = '6rem 6rem 20rem';
      gridPadding = '0 7rem 7rem';
    }

    return (
      <div style={{ backgroundColor: colors.light }}>
        <Section
          bottomAngle={8}
          bottomMargin={2}
          backgroundColor={colors.light}
          contentStyle={{
            marginBottom: topShift,
            padding: posterPadding,
          }}
        >
          <div style={{ maxWidth: '130rem', margin: 'auto' }}>
            <ScenePoster
              backgroundColor={imageColors(masterClip.scene_colors).dark}
              // lqip={masterClip.scene_lqip}
              thumbnail={masterClip.scene_thumbnail}
              poster={masterClip.scene_poster}
              color={Color(colors.highlight)
                .alpha(0.85)
                .string()}
              typeName="scene"
              clipCount={allClips.length}
              title={masterClip.scene_name}
              description={masterClip.scene_description}
            />
          </div>
        </Section>

        {!splitClips && (
          <Section
            topAngle={8}
            topMargin={0}
            backgroundColor={colors.dark}
            contentStyle={{ paddingTop: bottomShift }}
          >
            <div style={{ padding: gridPadding, paddingBottom: '10rem' }}>
              <div style={{ maxWidth: '150rem', margin: 'auto' }}>
                <ClipThumbnailGrid
                  clips={allClips}
                  colorA={colors.dark}
                  colorB={colors.highlight}
                />
              </div>
            </div>
          </Section>
        )}

        {splitClips && (
          <div>
            <Section
              topAngle={8}
              topMargin={0}
              bottomAngle={0}
              backgroundColor={colors.dark}
              contentStyle={{ paddingTop: bottomShift }}
            >
              <div style={{ padding: gridPadding }}>
                <div style={{ maxWidth: '130rem', margin: 'auto' }}>
                  <H5
                    style={{
                      color: colorTextDark,
                      marginBottom: '1.5rem',
                    }}
                  >{`${matchingClips.length} matching clip${matchingClips.length ===
                  1
                    ? ''
                    : 's'}`}</H5>
                  <ClipThumbnailGrid
                    clips={matchingClips}
                    colorA={colors.dark}
                    colorB={colors.highlight}
                  />
                </div>
              </div>
            </Section>
            {!!otherClips.length && (
              <Section topAngle={0}>
                <div style={{ padding: gridPadding }}>
                  <div style={{ maxWidth: '150rem', margin: 'auto' }}>
                    <H5
                      style={{
                        color: colorTextLight,
                        paddingTop: '5rem',
                        marginBottom: '1.5rem',
                      }}
                    >{`${otherClips.length} more clip${otherClips.length === 1
                      ? ''
                      : 's'} in this scene`}</H5>
                    <ClipThumbnailGrid
                      clips={otherClips}
                      colorA={colors.dark}
                      colorB={colors.highlight}
                    />
                  </div>
                </div>
              </Section>
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
    colors: state.ui.colors,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateColors: colors => dispatch(setColors(colors)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SceneLayout);



// WEBPACK FOOTER //
// ./src/components/SceneLayout/SceneLayout.js